<template>
  <div class="animated fadeIn">
    <br />
    <b-row>
      <b-col sm="12">
        <b-alert variant="primary" show class="text-center"><h5><b>Passo 2:</b> Confirme a capa ou volte para escolher outra!</h5></b-alert> 
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12" v-if="temporaryDesign">
        <b-card>
          <div slot="header" class="text-center">
            <strong>Escolher Capa</strong>
          </div>
          <b-form class="text-center">
            <img
              v-show="loaded && !this.isMobileScreen"
              @error="notLoaded()"
              v-on:load="loaded=true"
              style="max-height: 450px;"
              v-bind:src="fullImage"
            />
            <img
              v-show="loaded && this.isMobileScreen"
              @error="notLoaded()"
              v-on:load="loaded=true"
              style="max-height: 300px; max-width: 100%;"
              v-bind:src="fullImage"
            />
            <spinner v-if="!loaded"></spinner>

            <br/>
            <br/>
            <b-row>
              <b-col sm="4" offset-sm="4">
                <button
                  v-bind:href="temporaryDesign.fullImage"
                  @click.prevent="confirmCover(temporaryDesign.fullImage)"
                  class="btn btn-block btn-primary m-t"
                  download
                >
                  <i class="fa fa-check"></i>&nbsp; Usar esta capa
                </button>
                <button
                  v-bind:href="temporaryDesign.fullImage"
                  @click.prevent="chooseAnotherCover(temporaryDesign.fullImage)"
                  class="btn btn-block btn-outline-primary bg-white m-t"
                  download
                >
                  <i class="fa fa-ban"></i>&nbsp; Voltar e escolher outra capa
                </button>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import service from "./../service";
import Multiselect from "vue-multiselect";
import Spinner from "./Spinner";
import Config from "../config";
import { isIOS } from "mobile-device-detect";
import { isMobile } from "mobile-device-detect";
import axios from "axios";
import SubtitleBox from "./SubtitleBox"
import RelatedPosts from "./RelatedPosts"

export default {
  name: "SaveDesign",
  props: {
    idEbook: undefined
  },
  data() {
    return {
      loaded: false,
      selectedCategories: [],
      taggingSelected: null,
      categoriesList: [],
      temporaryDesign: undefined,
      random: Math.random(),
      savingTemplate: false,
      me: undefined,
      isIOS: isIOS,
      isMobileScreen: isMobile,
      canDownloadFree: false,
      color: ""
    };
  },
  computed: {
    fullImage: function() {
      return this.temporaryDesign.fullImage + "?" + this.random;
    },
    watermarked: function() {
      return (
        (this.temporaryDesign.watermarkedNeutral
          ? this.temporaryDesign.watermarkedNeutral
          : this.temporaryDesign.watermarked
          ? this.temporaryDesign.watermarked
          : this.fullImage) +
        "?" +
        this.random
      );
    },
    isAdmin: function() {
      return localStorage.admin;
    },
    templateName() {
      return localStorage.templateName;
    },
    whitelabelName() {
      return localStorage.whitelabelName;
    },
    isInstagramBrowser: function() {
      var str = navigator.userAgent;
      var i = str.indexOf("Instagram");
      if (i <= -1) {
        return false;
      }
      return true;
    },
    currentRouteName() {
        return this.$route.name;
    }
  },
  methods: {
    confirmCover: function(img) {
      service.createCustomEbookRequestV2(img).then((result) => {
        console.log({id: this.$route.params.idEbook, idEbookRequest: result.id});
        this.$router.push({ name: 'CustomChooseEbookPages', params: {id: this.$route.params.idEbook, idEbook: result.id}});
      });
    },
    chooseAnotherCover: function() {
      let newRoute = "/ebook/" + this.$route.params.idEbook + "/cover";
      this.$router.push(newRoute);
    },
    notLoaded: function() {
      setTimeout(() => (this.random = Math.random()), 1000);
    },
    addTag: function(newTag) {
      const tag = {
        name: newTag
      };
      this.categoriesList.push(tag);
      this.selectedCategories.push(tag);
    },
    getAllCategories: function() {
      return fetch(baseURL + "categories", {
        method: "GET"
      }).then(function(response) {
        if (response && response.status && response.status === 200) {
          return response.json();
        } else {
          return Promise.reject();
        }
      });
    },
    downloadItem(url) {
      axios
        .get(url, { responseType: "blob" })
        .then(({ data }) => {
          const blob = new Blob([data], { type: "image/png" });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = localStorage.whitelabelName + ".png";
          link.click();
        })
        .catch(error => console.error(error));
    },
    saveTemplate: function() {
      this.savingTemplate = true;
      var express = false;
      var advanced = false;

      if (this.temporaryDesign.expressEdition) {
        express = JSON.parse(this.temporaryDesign.expressEdition);
      }
      if (this.temporaryDesign.advancedEdition) {
        advanced = JSON.parse(this.temporaryDesign.advancedEdition);
      }

      service
        .saveTemplate({
          temporaryTemplateId: this.temporaryDesign._id,
          categories: this.selectedCategories,
          expressEdition: express,
          advancedEdition: advanced,
          weight: this.temporaryDesign.weight
        })
        .then(
          response => {
            this.savingTemplate = false;
            this.$router.push("/design/mine/");
          },
          () => {
            this.savingTemplate = false;
            this.showError = true;
          }
        );
    },
    saveAdminTemplate: function() {
      let express = false;
      let advanced = false;
      let weight = 0;
      let frame = false;

      if (this.temporaryDesign.expressEdition) {
        express = JSON.parse(this.temporaryDesign.expressEdition);
      }
      if (this.temporaryDesign.advancedEdition) {
        advanced = JSON.parse(this.temporaryDesign.advancedEdition);
      }
      if (this.temporaryDesign.weight) {
        weight = JSON.parse(this.temporaryDesign.weight);
      }

      if (this.temporaryDesign.frame) {
        frame = JSON.parse(this.temporaryDesign.frame);
      }

      service
        .saveAdminTemplate({
          temporaryTemplateId: this.temporaryDesign._id,
          categories: this.selectedCategories,
          expressEdition: express,
          advancedEdition: advanced,
          weight: weight,
          subtitle: this.temporaryDesign.subtitle,
          frame: frame,
          originalVersion: this.temporaryDesign.originalVersion,
          color: this.color
        })
        .then(
          response => {
            if (response && response.id) {
              this.$router.push("/design/preview/" + response.id);
            } else {
              this.$router.push({ name: 'Busca', params: { page: 1 }});
            } 
          },
          () => {
            this.showError = true;
          }
        );
    }
  },
  mounted: function() {
    
  },
  created: function() {
    if (this.$route.params.token) {
      let token = this.$route.params.token.replace("instagram1a","");
      localStorage.sessionId = token;
    }
    
    if (this.$route.params.id) {
      service.getTemporaryDesign(this.$route.params.id).then(
        response => {
          this.temporaryDesign = response.temporaryDesign;
          this.temporaryDesign.expressEdition = true;
          this.temporaryDesign.advancedEdition = true;
          let preselectedCategories = response.preselectedCategories;

          if (this.temporaryDesign.originalIsPersonal) {
            this.canDownloadFree = true;
          }
        },
        () => {
          this.showError = true;
        }
      );
    }
  },
  components: { Multiselect, Spinner, SubtitleBox, RelatedPosts }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



<style lang="css" scoped>
.background-multiSelect >>> .multiselect__tag {
  background: #20a8d8 !important;
}
</style>


<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
